

const AboutUs = ()=>{

    return(
        <div className="container"><div className="row"><div className="site-main col-sm-12 full-width">
      <article id="post-3067" className="post-3067 page type-page status-publish hentry">
        <div className="entry-content">
          <p style={{textAlign: 'justify'}}><span data-mce-type="bookmark" style={{display: 'inline-block', width: 0, overflow: 'hidden', lineHeight: 0}} className="mce_SELRES_start">﻿</span>در سال 1395 مجموعه گردشگری جمه صب ابتدا با هدف برگزاری تورهای پرانرژی و متفاوت با نام جمعه صبح شروع به فعالیت نمود و پس از مدتی نام <strong>جمعه صبح</strong> به <strong><a href="http://jomesob.com/tours/" rel="noopener" target="_blank">جمه صب</a></strong> تغییر یافت. از همان سال 95 با تور دامغان شروع به برگزاری تورهای ایرانگردی نموده و سپس تورهای ایرانگردی با رویکرد طبیعتگردی را برگزار کردیم و در پی آن تورهای متفاوت و متنوعی از جمله تورهای طبس، چابهار، قشم، بوشهر، خوزستان، ایلام، لرستان، کردستان و … را به مخاطبین عزیزمان ارائه نمودیم.</p>
          <p>همین اینک برند گردشگری جمه صب تحت نام آژانس گردشگری مایان، با برخورداری از تجربیات چندین ساله و با استفاده از لیدرهای باتجربه، اقدام به برگزاری تورهای متفاوت، متنوع و جذاب در سراسر ایران و همچنین کشورهای همسایه می نماید.</p>
          <p style={{textAlign: 'center'}}>
            با تشکر از همراهی شما<strong><br />
            </strong>مجموعه گردشگری <a href="http://jomesob.com/" rel="noopener" target="_blank">جمه صب</a></p>
        </div>{/* .entry-content */}
        <footer className="entry-footer">
        </footer>{/* .entry-footer */}
      </article>{/* #post-## */}
    </div></div></div>

    )

}

export default AboutUs